import LoginView from './components/login';
import NotFoundView from './components/404';
import DashView from './components/dash';
import ContentView from './components/aroma';
import RadiusView from './components/radius';
import SettingView from './components/setting';
import ResetPasswordView from './components/reset-password';

// Routes
const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { guest: true },
  },
  {
    path: '/not-in-use',
    name: 'home',
    component: DashView,
    meta: { auth: true },
    children: [
      {
        path: '/performance',
        name: 'performance',
        component: ContentView,
        meta: { type: 'campaign' }
      },
      {
        path: '/performance/:id',
        name: 'performance_id',
        component: ContentView,
        meta: { type: 'campaign' }
      },
      {
        path: '/rotator',
        name: 'rotator',
        component: ContentView,
        meta: { type: 'rotator' }
      },
      {
        path: '/rotator/:id',
        name: 'rotator_id',
        component: ContentView,
        meta: { type: 'rotator' }
      },
      {
        path: '/setting',
        name: 'setting',
        component: SettingView,
        meta: { impersonation: true },
      },
    ]
  },
  {
    path: '/rotator/:id/setup',
    name: 'setup',
    component: RadiusView,
    meta: { auth: true, type: 'rotator' }
  },
  {
    path: '/affiliate/:affiliate_id/reset-password/:hash',
    name: 'reset_password',
    component: ResetPasswordView
  },
  {
    // not found handler
    path: '*',
    redirect: { name: 'performance' },
    meta: { guest: true, auth: true }
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js